import ChartMixin from "@/components/Charts/mixins/bar-chart";

export default {
	name: "DeliveryNotesUnsignedProductLoadedChart",

	mixins: [ ChartMixin ],

	props: {
		item: Object,
		items: Array
	},

	data: () => ( {
		averageObjectValuePath: "stats.numUnsignedProductLoadedFields",
		title: "Unsigned Product Loaded Fields",
		yAxisLabel: "Missing Signatures (Count)"
	} ),

	computed: {
		barData() {
			if ( this.item ) {
				return [
					this.item.stats.numUnsignedProductLoadedFields,
					this.averageValue
				];
			}

			return this.items.map( item => item.stats.numUnsignedProductLoadedFields );
		},

		labels() {
			if ( this.item ) {
				return [
					this.item.driver.user.name.split( " " ),
					[ "All drivers", "average" ]
				];
			}

			return this.items.map( item => item.driver.user.name.split( " " ) );
		}
	}
};
